import { Trans } from '@lingui/macro'
import { Typography } from '@mui/material'
import { ReduxState } from 'app/redux/ReduxInterfaces'
import PopUpDialogue from 'app/views/grants/PopUpDialogue'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { bilingualDateFormat } from '../Formats'
import './MaintenanceWarningDialog.css'

interface MaintenanceWarningDialogProps {
  maintenanceStartDate: string
  maintenanceEndDate: string
  dialogStartDate?: string
  clousureStartDate: string
}

const DIALOG_DISMISSED_KEY = 'maintenanceWarningDismissed'

const MaintenanceWarningDialog: React.FC<MaintenanceWarningDialogProps> = ({
  maintenanceStartDate,
  maintenanceEndDate,
  dialogStartDate,
  clousureStartDate
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const language = useSelector<ReduxState, string>(
    (state) => state.user.language
  )
  useEffect(() => {
    const wasDismissed = localStorage.getItem(DIALOG_DISMISSED_KEY)

    if (wasDismissed === 'true') {
      setIsDialogOpen(false)
      return
    }

    const now = moment()
    const startDate = dialogStartDate != null ? moment(dialogStartDate) : null
    const endDate = moment(maintenanceStartDate)

    const shouldShow =
      (startDate === null || now.isSameOrAfter(startDate, 'day')) &&
      now.isBefore(endDate, 'day')

    setIsDialogOpen(shouldShow)
  }, [dialogStartDate, maintenanceStartDate])

  const handleClose = (): void => {
    localStorage.setItem(DIALOG_DISMISSED_KEY, 'true')
    setIsDialogOpen(false)
  }

  return (
    <PopUpDialogue
      open={isDialogOpen}
      dialogTitle={
        <Trans>MAINTENANCE_WARNING_DIALOG_TITLE</Trans>
      }
      dialogMessege={
        <Typography
          sx={{
            lineHeight: '20px',
            fontSize: '14px'
          }}
        >
          <div className='maintenance-warning-dialog-content'>
            <div>
              <Trans>MAINTENANCE_DIALOG_CLOUSURE_FRAGMENT</Trans>{' '}
              <b>{bilingualDateFormat(clousureStartDate, language)}</b>{' '}
              <b><Trans>MAINTENANCE_DIALOG_TO_FRAGMENT</Trans></b>{' '}
              <b>{bilingualDateFormat(maintenanceEndDate, language)}</b>{'. '}
              <Trans>MAINTENANCE_DIALOG_MESSAGES_FRAGMENT</Trans>{' '}
            </div>
            <div>
              <b><Trans>MY_CENTER</Trans></b>{' '}
              <Trans>MAINTENANCE_DIALOG_UNDERGO_FRAGMENT</Trans>{' '}
              <b>{bilingualDateFormat(maintenanceStartDate, language)}</b>{' '}
              <b><Trans>MAINTENANCE_DIALOG_TO_FRAGMENT</Trans></b>{' '}
              <b>{bilingualDateFormat(maintenanceEndDate, language)}</b>{'. '}
              <Trans>MAINTENANCE_DIALOG_NOT_ABLE_TO_LOGIN_FRAGMENT</Trans>{' '}
            </div>
            <div>
              <Trans>MAINTENANCE_DIALOG_WISHING_MESSAGE</Trans>
            </div>
          </div>
        </Typography>
      }
      closeFunction={handleClose}
      okText={<Trans>MAINTENANCE_DIALOG_BUTTON_TITLE</Trans>}
      confirmFunction={handleClose}
    />
  )
}

export default MaintenanceWarningDialog
